export const products = [
  {
    id: 1,
    name: "HYBRID PRO",
    desc: "Advanced Aerodynamic Hybrid Wiper Blade Technology for streak-free cleaning.",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSXCqwU5oaDVtHzyKoMHzeMcC2ieLoYUbsuzg&s",
    category: "Hybrid Wipers",
    height: "65 cm",
    material: "Silicone + Metal Frame",
    weight: "450 g",
    usage: "Indoor and Outdoor surfaces, Floors and Windows"
  },
  {
    id: 2,
    name: "SILICONE BEAM",
    desc: "Water-repellent flat silicone wiper for smooth cleaning of glass surfaces.",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0BwlUZxl21vBZApSfftcsLxdOYowZKCi0HQ&s",
    category: "Flat / Beam Wipers",
    height: "60 cm",
    material: "Silicone Rubber",
    weight: "380 g",
    usage: "Windows, Mirrors, Glass panels"
  },
  {
    id: 3,
    name: "HEAVY DUTY",
    desc: "Durable steel frame wipers ideal for commercial use on larger surfaces.",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR1i5JVG1y7-5pZ5k_bIJicobCey97i69F16A&s",
    category: "Standard Wipers",
    height: "70 cm",
    material: "Stainless Steel + Rubber Blade",
    weight: "600 g",
    usage: "Warehouses, Factory floors, Outdoor large areas"
  },
  {
    id: 4,
    name: "REAR GUARD",
    desc: "Specialized rear wipers for precise cleaning of smaller surfaces.",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR1i5JVG1y7-5pZ5k_bIJicobCey97i69F16A&s",
    category: "Wiper Refills",
    height: "50 cm",
    material: "Rubber",
    weight: "300 g",
    usage: "Hatchbacks, Small windows, Indoor floors"
  },
  {
    id: 5,
    name: "FLOOR MASTER",
    desc: "Ergonomic floor wiper for wet and dry cleaning, wide coverage.",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR1i5JVG1y7-5pZ5k_bIJicobCey97i69F16A&s",
    category: "Standard Wipers",
    height: "80 cm",
    material: "Plastic + Rubber Blade",
    weight: "550 g",
    usage: "Indoor floors, Tiles, Marble"
  },
  {
    id: 6,
    name: "BATHROOM WIPER",
    desc: "Compact wiper for tiles and wet surfaces, easy to store.",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSXCqwU5oaDVtHzyKoMHzeMcC2ieLoYUbsuzg&s",
    category: "Flat / Beam Wipers",
    height: "45 cm",
    material: "Silicone Rubber",
    weight: "250 g",
    usage: "Bathrooms, Washrooms, Tile surfaces"
  },
  {
    id: 7,
    name: "GLASS / WINDOW WIPER",
    desc: "Streak-free cleaning blade for windows and mirrors.",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0BwlUZxl21vBZApSfftcsLxdOYowZKCi0HQ&s",
    category: "Hybrid Wipers",
    height: "55 cm",
    material: "Silicone + Metal",
    weight: "320 g",
    usage: "Windows, Mirrors, Glass doors"
  },
  {
    id: 8,
    name: "KITCHEN WIPER",
    desc: "Small, precise wiper for slabs, counters, and tiles.",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0BwlUZxl21vBZApSfftcsLxdOYowZKCi0HQ&s",
    category: "Wiper Refills",
    height: "40 cm",
    material: "Rubber + Plastic",
    weight: "200 g",
    usage: "Kitchen counters, Tiles, Small surfaces"
  },
  {
    id: 9,
    name: "HEAVY FLOOR WIPER",
    desc: "Extra-large wiper for industrial and commercial floor cleaning.",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR1i5JVG1y7-5pZ5k_bIJicobCey97i69F16A&s",
    category: "Standard Wipers",
    height: "90 cm",
    material: "Stainless Steel + Rubber Blade",
    weight: "750 g",
    usage: "Factories, Warehouses, Outdoor areas"
  },
  {
    id: 10,
    name: "RECHARGEABLE WIPER",
    desc: "Motorized wiper for effortless cleaning of floors and glass.",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTpvLFIkHH4ydUMM9WwkuA8cwb7J3qS1if0HQ&s",
    category: "Hybrid Wipers",
    height: "65 cm",
    material: "Plastic + Rubber + Electronics",
    weight: "800 g",
    usage: "Floors, Windows, Large surfaces"
  }
];